'use client'

import React, { useEffect, useState } from 'react'
import SearchNav from './header-search-nav-pages'
import HeaderLogo from './header-logo'
import MobileHeaderMenu from './mobile-header-menu'
import Hamburger from '@dustin-web/microsite-components/src/hamburger'
import MiniCart from './cart/minicart'
import { MobileStateActionType, useHeaderContext } from './header-context'
import { useScrollLock } from '@dustin-web/microsite-components/src/hooks'
import Icon from '@dustin-web/microsite-components/src/icon'
import FavoritesMenu from './header-favorites'
import HeaderIconMenu from './header-account-mobile-menu'
import { useAuth } from '@dustin-web/microsite-components/src/auth'
import CompareMenu from './header-compare-menu'
import Overlay from '@dustin-web/microsite-components/src/overlay/overlay'
import AssistiveCart from '@dustin-web/microsite-baselayout/src/components/header/cart/assistive-cart'
// import CategoryNavigationItemList from './category-navigation-item-list'

const HeaderMobile = () => {
  const { isAuthenticated } = useAuth()
  const { mobile, dispatchMobile } = useHeaderContext()
  const [triggerInputFocus, setTriggerInputFocus] = useState(false)

  useScrollLock(mobile.showMenu || mobile.showMyAccount || mobile.showSearch)

  useEffect(() => {
    if (mobile.showMenu || mobile.showMyAccount || mobile.showSearch) {
      // Fix for chrome address bar bug on android
      document.body.classList.add('u-fixed')
      document.body.classList.add('u-w-100')
    } else {
      document.body.classList.remove('u-fixed')
      document.body.classList.remove('u-w-100')
    }
  }, [mobile.showMenu, mobile.showMyAccount, mobile.showSearch])

  const handleHamburgerClick = () => {
    dispatchMobile({
      type: mobile.showMenu ? MobileStateActionType.HIDE_MENU : MobileStateActionType.SHOW_MENU,
    })

    dispatchMobile({
      type:
        mobile.showMenu && mobile.showMyAccount
          ? MobileStateActionType.HIDE_ACCOUNT
          : MobileStateActionType.HIDE_ACCOUNT,
    })
    const resetMobileStateWhenClose = () => {
      if (!mobile.showMenu && mobile.breadcrumbs) {
        // close all sub menus, registered in breadcrumbs
        mobile.breadcrumbs.forEach(breadcrumb => {
          breadcrumb.action()
        })

        // reset breadcrumbs
        dispatchMobile({
          type: MobileStateActionType.SET_BREADCRUMBS,
          payload: { breadcrumbs: null },
        })
      }
    }
    resetMobileStateWhenClose()
  }

  const handleMyAccountClick = () => {
    dispatchMobile({
      type: mobile.showMyAccount
        ? MobileStateActionType.HIDE_ACCOUNT
        : MobileStateActionType.SHOW_ACCOUNT,
    })

    dispatchMobile({
      type:
        mobile.showMenu && mobile.showMyAccount
          ? MobileStateActionType.HIDE_MENU
          : MobileStateActionType.HIDE_MENU,
    })
  }

  useEffect(() => {
    triggerInputFocus && setTriggerInputFocus(false)
  }, [triggerInputFocus])

  return (
    <>
      <Overlay
        show={mobile.showSearch}
        layer={'header'}
        onClick={() => MobileStateActionType.HIDE_SEARCH}
      />
      <header className="c-mobile-header">
        <nav>
          <div className="c-mobile-header-base container">
            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center u-mr-16">
                <Hamburger
                  open={mobile.showMenu}
                  onToggle={handleHamburgerClick}
                  className="u-mr-16"
                />
                <HeaderLogo />
              </div>
              <div className="d-flex align-items-center justify-content-end flex-grow-1">
                <CompareMenu />
                <FavoritesMenu />
                <div className="u-mr-16 d-flex align-items-center justify-content-center">
                  {isAuthenticated ? (
                    <Icon name="user" onClick={handleMyAccountClick} className="i-24" />
                  ) : (
                    <a href="/login" className="u-h-24" aria-label="Log in">
                      <Icon name="user" className="i-24" />
                    </a>
                  )}
                </div>
                <AssistiveCart />
                <MiniCart />
              </div>
            </div>
          </div>
          {!mobile.showMyAccount && (
            <div className="c-mobile-header-search container">
              <SearchNav triggerInputFocus={triggerInputFocus} />
            </div>
          )}
          <MobileHeaderMenu />
          <HeaderIconMenu />
        </nav>
      </header>
    </>
  )
}
export default HeaderMobile
